import React, { FC } from 'react';
import { FormControl } from 'react-bootstrap';

export interface Props {
  id?: string;
  enabled?: boolean | undefined;
  placeholder?: string | undefined;
  value: number | undefined;
  touched?: boolean;
  error?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<any>;
  size?: 'sm' | 'lg';
  rest?: Record<string, unknown>;
  style?: React.CSSProperties;
  maxValue?: number;
  minValue?: number;
  isInvalid?: boolean;
}

const NumberInput: FC<Props> = ({
  id,
  value,
  touched,
  error,
  enabled = true,
  placeholder,
  onChange,
  onBlur,
  size,
  rest,
  style,
  maxValue,
  minValue,
}: Props) => {
  return (
    <FormControl
      type="number"
      size={size}
      min={minValue}
      max={maxValue}
      name={id}
      value={!value && value !== 0 ? '' : value}
      isValid={touched && !error}
      isInvalid={touched && !!error}
      disabled={!enabled}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      style={style}
      {...rest}
      onWheel={(e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()}
    />
  );
};

export default NumberInput;
